export const COMETCHAT_CONSTANTS = {
  APP_ID: "2693178751988b98",
  REGION: "IN",
  AUTH_KEY: "5e64ba711d881f692e05217e17714c596a090f5e",
};
